import { Injectable } from '@angular/core';
import { DetailedEntityDataService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';


@Injectable()
export class MaintainReportDataService extends DetailedEntityDataService {

    public maxValue: number = 0;

    // to update detail idProperty [parm_no] when adding new line item based on max parm_no from loadbypage
    public initializeValuesForNewLineItem(newRow: any) {
        const idProperty = this.detailsSearchParams.idProperty;
        let newLineNumber: number;
        if (this.maxValue === 0) {
            this.detailsSearchService.getPagedData().pageRows.forEach((row: any) => {
                this.maxValue = parseInt(row.cells[idProperty].cVal, 10);
            });
            newLineNumber = this.maxValue + 1;
        } else {
            newLineNumber = this.maxValue + 1;
        }
        this.maxValue += 1;
        newRow.cells[idProperty].cVal = newLineNumber.toString();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/maintain-report/services/maintain-report-data.service.ts